import { createContext, ReactNode, useMemo } from 'react'
import { observer } from 'mobx-react-lite'
import type { Permission } from 'app/types/entities'
import { useAuthStore } from 'app/stores/StoreContext'

/**
 * Context value providing the current user's permissions and role type.
 */
export type UserPermissionsContextType = {
  permissions: Permission[] | undefined
  isOrgRole: boolean
}

export const UserPermissionsContext = createContext<UserPermissionsContextType>({
  permissions: undefined,
  isOrgRole: false,
})

export const UserPermissionsProvider = observer(function UserPermissionsProvider({
  children,
}: {
  children: ReactNode
}) {
  const auth = useAuthStore()

  const value = useMemo(
    () => ({
      permissions: auth.permissions as Permission[] | undefined,
      isOrgRole: auth.isOrgRole,
    }),
    [auth.permissions, auth.isOrgRole],
  )

  return <UserPermissionsContext.Provider value={value}>{children}</UserPermissionsContext.Provider>
})
